module.exports = __webpack_public_path__ + "img/contact_employer_in_person.f8366221.jpg";